import Countdown from "react-countdown";
import React, { useState, useCallback, useEffect, useRef } from "react";
import { Line } from "../../../style";
import { FiClock } from "react-icons/fi";
import { useApi } from "../../../hooks/api";
import { Container, ContainerTextStep, Content, ContentCountdown, TextDescription, TextFooter, TextHeaderStep, TextStep } from "./style";
import { useGlobal } from "../../../hooks/global";
import { ModalHeader } from "../../../components/ModalHeader";
import { ModalGeneric } from "../../../components/ModalGeneric";
import { ContentOrLoading } from "../../../components/Loadings/ContentOrLoading";
import { SettingsIPhone } from "../../../components/SvgComponents/Icons/SettingsIPhone";
import { SettingsAndroid } from "../../../components/SvgComponents/Icons/SettingsAndroid";
import { io } from "socket.io-client";
import { getSocket } from "../../../services/socket";

interface IModalSuperlogicaProps {
    onCancel: Function
    onSave: Function
}

const msToTime = (duration: number) => {
    let seconds: any = parseInt(((duration / 1000) % 60) + "", 10)
    let minutes: any = parseInt(((duration / (1000 * 60)) % 60) + "", 10)
    let hours: any = parseInt(((duration / (1000 * 60 * 60)) % 24) + "", 10)

    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;

    return hours + "h" + " : " + minutes + "m" + " : " + seconds + "s";
}

export const ModalWppConection: React.FC<IModalSuperlogicaProps> = (props) => {
    const { onCancel, onSave } = props

    const { api } = useApi()
    const { theme, notify } = useGlobal()

    const [loading, setLoading] = useState(true)

    const [qrCode, setQrCode] = useState<string | null>(null)

    const getNewInstance = useCallback(async () => {
        setLoading(true)

        try {
            const { data } = await api.post("/integrations/create-integration-wpp")

            setQrCode(data.qrCode)
        } catch (err) {
            notify("Erro ao tentar obter nova instância", "error")
        }

        setLoading(false)
    }, [api])

    const onComplete = useCallback(async () => {
        onSave()
    }, [])

    useEffect(() => { getNewInstance() }, [])

    useEffect(() => {
        if (!qrCode) return;

        const fetchStatus = async () => {
            try {
                const response = await api.get('/testing-wpp'); 

                if(response?.data?.message === 'conectando') {
                    notify('WhatsApp iniciou conexão', 'success');
                    onSave();
                }
            } catch (error) {
                console.error('Erro ao buscar status:', error);
            }
        };

        fetchStatus();

        const interval = setInterval(fetchStatus, 5000);

        return () => clearInterval(interval);
    }, [qrCode]);

    const canvasRef = useRef<HTMLCanvasElement>(null);
    useEffect(() => {
        if (!qrCode) return;

        const img = new Image();
        img.src = qrCode;
        img.crossOrigin = "Anonymous";

        img.onload = () => {
            const canvas = canvasRef.current;
            if (!canvas) return;

            const ctx = canvas.getContext("2d");
            if (!ctx) return;

            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);

            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;

            for (let i = 0; i < data.length; i += 4) {
                const red = data[i];
                const green = data[i + 1];
                const blue = data[i + 2];

                if (green > red && green > blue) {
                    data[i] = 0;
                    data[i + 1] = 0;
                    data[i + 2] = 0;
                }
            }

            ctx.putImageData(imageData, 0, 0);
            setQrCode(canvas.toDataURL());
        };
    }, [qrCode]);

    return (
        <ModalGeneric open onClose={() => { }}>
            <Container theme={theme}>

                <ModalHeader
                    title={"Integração com o WhatsApp"}
                    subTitle={"Aguarde o QR Code aparecer e escaneie com o WhatsApp que deseja integrar"}
                    onCancel={() => onCancel()}
                    theme={theme}
                />

                <ContentOrLoading loading={loading} theme={theme} type="wave">
                    <Content>
                        <div>
                            <TextHeaderStep>Utilize o seu WhatsApp:</TextHeaderStep>

                            <TextDescription>
                                Conecte seu WhatsApp para enviar mensagens automatizadas através de
                                nosso sistema.
                            </TextDescription>

                            <ContainerTextStep>
                                <TextStep>1. Abra o WhatsApp no seu celular.</TextStep>

                                <TextStep>
                                    2. Toque em <b>Mais opções</b> <SettingsAndroid background={theme === 'light' ? '#f4f6f6' : '#151515'} color={theme === 'light' ? '#566573' : 'gray'} border={theme === 'light' ? '#d5d8dc' : ''} /> no
                                    Android ou em <b>Configurações</b> <SettingsIPhone background={theme === 'light' ? '#f4f6f6' : '#151515'} color='#566573' border={theme === 'light' ? '#d5d8dc' : ''} /> no iPhone.
                                </TextStep>

                                <TextStep>3. Toque em <b>Dispositivos conectados</b> e, em seguida, em <b>Conectar dispositivo</b>.</TextStep>

                                <TextStep>4. Aponte seu celular para esta tela para escanear o QR code.</TextStep>
                            </ContainerTextStep>

                            <TextFooter>
                                WebCheckin.app não é um produto associado ao WhatsApp INC, Facebook INC, META ou qualquer uma de suas empresas, e não possui relação comercial ou consentimento para uso. A utilização do sistema para envio de mensagens é de inteira responsabilidade do usuário, que deve seguir rigorosamente as diretrizes da plataforma para evitar banimento ou bloqueios.
                            </TextFooter>
                        </div>

                        <canvas ref={canvasRef} style={{ display: "none" }} />
                        <img src={qrCode ?? ''} alt="QR Code" style={{ height: 280, objectFit: 'scale-down' }} />

                    </Content>
                </ContentOrLoading>

                <ContentCountdown>
                    {!loading && (
                        <Line style={{ alignItems: "center", color: "#FAAD14", gap: 5, justifyContent: "center", marginBottom: 16 }}>
                            <FiClock size={15} />
                            <Line style={{ fontSize: 14, gap: 5 }}>
                                Você têm
                                <Countdown
                                    date={(new Date()).getTime() + 60 * 1000}
                                    intervalDelay={0}
                                    precision={3}
                                    onComplete={onComplete}
                                    renderer={props => <b style={{ fontSize: 14 }}>{msToTime(props.total)}</b>}
                                />
                                para logar
                            </Line>
                        </Line>
                    )}
                </ContentCountdown>
            </Container>
        </ModalGeneric>
    )
}